import styled from '@emotion/styled';

import { Tabs, type TabType } from '@innovamat/glimmer-components';

const TabsWrapper = styled.div`
  margin-top: 0.5rem;
  border-bottom: 1px solid
    ${({ theme }) => theme.tokens.color.alias.cm.border['border-subtle'].value};
`;

type Props = {
  tabs: TabType[];
};

function SchoolClassroomsTabs({ tabs }: Props) {
  return (
    <>
      {tabs.length > 0 && (
        <TabsWrapper>
          <Tabs tabs={tabs} />
        </TabsWrapper>
      )}
    </>
  );
}

export { SchoolClassroomsTabs };
